import { Text } from '@vkontakte/vkui';
import React, { memo, useCallback, useEffect } from 'react';
import { summerPromo2026AnalyticsName } from 'reactApp/appHelpers/featuresHelpers/features/summerPromo2026';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { openSummerCampaign2026Modal } from 'reactApp/ui/SummerCampaign2026Modal/SummerCampaign2026Modal.helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './DiscountCardSummerPromo2026.css';

export const DiscountCardSummerPromo2026 = memo(function DiscountCardSummerPromo2026() {
    const handleClick = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.button,
            action: 'click',
            name: `${summerPromo2026AnalyticsName}_discount`,
            dwh_enabled: true,
            dwh_enabled_fields: [['name', 'platform', 'webview']],
        });
        openSummerCampaign2026Modal();
    }, []);

    useEffect(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.button,
            action: 'show',
            name: `${summerPromo2026AnalyticsName}_discount`,
            dwh_enabled: true,
            dwh_enabled_fields: [['name', 'platform', 'webview']],
        });
    }, []);

    return (
        <div className={styles.root}>
            <Text className={styles.title}>Призы и место для фото</Text>
            <Text className={styles.text}>Крутите колесо и выигрывайте</Text>
            <Button primary theme="vk" sizeMode={ButtonSizeMode.small} className={styles.button} onClick={handleClick}>
                Мне повезёт
            </Button>
            <img src={`${cdnPackagesUrl}/static/cloud/promo/summer2026/right-discount-card.webp`} className={styles.img} />
        </div>
    );
});
